import { PipeTransform, Pipe } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatNumberToMonth',
})
export class FormatNumberToMonth implements PipeTransform {
  transform(mes: number): string {
    const date = moment().locale('pt-br');

    date.month(mes-1)

    return date.format('MMM');
  }
}
